import { FREQUENCY_LABELS, REF_DATE_LABELS, TIMING_LABELS } from '../types';
import type {
  Frequency,
  RecTiming,
  RefDate,
  TargetWeightMode,
  Weekday,
  WeekOfMonth,
} from '../types';

export const FREQUENCY_OPTIONS: Array<{ value: Frequency; label: string }> = [
  { value: 'D', label: FREQUENCY_LABELS.D },
  { value: 'W', label: FREQUENCY_LABELS.W },
  { value: 'M', label: FREQUENCY_LABELS.M },
  { value: 'Q', label: FREQUENCY_LABELS.Q },
  { value: 'SA', label: FREQUENCY_LABELS.SA },
  { value: 'A', label: FREQUENCY_LABELS.A },
];

// Lower number = more frequent. Used to constrain rebalance ≤ reconstitution.
export const FREQUENCY_ORDER: Record<Frequency, number> = {
  D: 0,
  W: 1,
  M: 2,
  Q: 3,
  SA: 4,
  A: 5,
};

export const WEEKDAY_OPTIONS: Array<{ value: Weekday; label: string }> = [
  { value: 'MON', label: 'Monday' },
  { value: 'TUE', label: 'Tuesday' },
  { value: 'WED', label: 'Wednesday' },
  { value: 'THU', label: 'Thursday' },
  { value: 'FRI', label: 'Friday' },
];

export const WEEK_OF_MONTH_OPTIONS: Array<{ value: WeekOfMonth; label: string }> = [
  { value: 1, label: '1st Week' },
  { value: 2, label: '2nd Week' },
  { value: 3, label: '3rd Week' },
  { value: 4, label: '4th Week' },
  { value: 'last', label: 'Last Week' },
];

export const ANCHOR_MONTH_OPTIONS: Array<{ value: number; label: string }> = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

// Reconstitution/rebalance timing within the period (backend RecTiming).
export const TIMING_OPTIONS: Array<{ value: RecTiming; label: string }> = [
  { value: 'CUSTOM_INTRA_MONTH', label: TIMING_LABELS.CUSTOM_INTRA_MONTH },
  { value: 'MONTH_END', label: TIMING_LABELS.MONTH_END },
  { value: 'MONTH_START', label: TIMING_LABELS.MONTH_START },
];

// Reference-data choices (backend RefDate). 1:1 with the enum — no
// translation. The short-frequency-only ones (PREV_BUSINESS_DAY / CUSTOM_LAG)
// are gated in the form per the backend rules.
export const REF_DATE_OPTIONS: Array<{ value: RefDate; label: string }> = [
  { value: 'PREV_BUSINESS_DAY', label: REF_DATE_LABELS.PREV_BUSINESS_DAY },
  { value: 'CUSTOM_LAG', label: REF_DATE_LABELS.CUSTOM_LAG },
  // Same-day as-of (T). Not day-based, so the form treats it like the period
  // refs below: available for M/Q/SA/A at every timing, disabled for D/W.
  { value: 'SAME_DAY', label: REF_DATE_LABELS.SAME_DAY },
  { value: 'PREV_MONTH_END', label: REF_DATE_LABELS.PREV_MONTH_END },
  { value: 'TWO_MONTHS_PRIOR', label: REF_DATE_LABELS.TWO_MONTHS_PRIOR },
  { value: 'THREE_MONTHS_PRIOR', label: REF_DATE_LABELS.THREE_MONTHS_PRIOR },
  { value: 'PREV_QUARTER_END', label: REF_DATE_LABELS.PREV_QUARTER_END },
  { value: 'PREV_YEAR_END', label: REF_DATE_LABELS.PREV_YEAR_END },
];

export const REBAL_TARGET_OPTIONS: Array<{
  value: TargetWeightMode;
  label: string;
}> = [
  { value: 'use_existing', label: 'Use Existing Weights' },
  { value: 'recompute', label: 'Recompute Weights' },
];

export const METHODOLOGY_OPTIONS: Array<{
  value: string;
  label: string;
  disabled: boolean;
}> = [
  { value: 'calendar_based', label: 'Calendar-Based', disabled: false },
  { value: 'drift_based', label: 'Drift-Based', disabled: true },
];
